var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecapCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.851,
    height: 17.851,
    viewBox: "0 0 17.851 17.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21601",
    "data-name": "Tracciato 21601",
    d: "M9.694,16.868a.94.94,0,0,0-.94.94v.555a.94.94,0,0,0,.94.939h.555a.94.94,0,0,0,.94-.939v-.555a.94.94,0,0,0-.94-.94Zm4.057,0a.939.939,0,0,0-.939.94v.555a.939.939,0,0,0,.939.939h.555a.939.939,0,0,0,.939-.939v-.555a.939.939,0,0,0-.939-.94Zm4.056,0a.939.939,0,0,0-.939.94v.555a.94.94,0,0,0,.939.939h.556a.939.939,0,0,0,.939-.939v-.555a.939.939,0,0,0-.939-.94Zm-4.056-4.057a.939.939,0,0,0-.939.939v.556a.939.939,0,0,0,.939.939h.555a.939.939,0,0,0,.939-.939V13.75a.939.939,0,0,0-.939-.939Zm4.056,0a.94.94,0,0,0-.939.939v.556a.94.94,0,0,0,.939.939h.556a.939.939,0,0,0,.939-.939V13.75a.939.939,0,0,0-.939-.939ZM6.681,10.377H20.564V20.564H6.681Zm13.7-3.7v.6A1.879,1.879,0,0,1,18.5,9.16h-.87a1.88,1.88,0,0,1-1.879-1.88c0-.033,0-.067,0-.1l.027-.5H11.459v.6A1.88,1.88,0,0,1,9.58,9.16H8.74A1.879,1.879,0,0,1,6.861,7.28v-.6h-.18A1.989,1.989,0,0,0,4.7,8.664v11.9a1.989,1.989,0,0,0,1.984,1.984H20.564a1.989,1.989,0,0,0,1.984-1.984V8.664a1.989,1.989,0,0,0-1.984-1.983ZM8.168,4.7V7.228a.94.94,0,0,0,.94.94h.1a.94.94,0,0,0,.94-.94V4.7Zm8.926,0V7.228a.939.939,0,0,0,.939.94h.1a.94.94,0,0,0,.939-.94V4.7Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_13198",
    "data-name": "Raggruppa 13198",
    transform: "translate(-4.697 -4.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_13197",
    "data-name": "Raggruppa 13197",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4265",
    "data-name": "Rettangolo 4265",
    width: 27.245,
    height: 27.245,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4266",
    "data-name": "Rettangolo 4266",
    width: 27.245,
    height: 27.245,
    transform: "translate(0 0)",
    fill: "#951a33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapCalendarIcon);
export default __webpack_public_path__ + "static/media/recap-calendar-icon.c9c16abfc71d7edc3ef03f2836c10cd4.svg";
export { ForwardRef as ReactComponent };